import { render, staticRenderFns } from "./QuestionTypeDragAndDrop.vue?vue&type=template&id=2b259210&"
import script from "./QuestionTypeDragAndDrop.vue?vue&type=script&lang=js&"
export * from "./QuestionTypeDragAndDrop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports